import React from "react";
import { Box, Typography, Grid, Divider, useTheme } from "@mui/material";
import {
  EmojiEvents,
  People,
  Storefront,
  Stars,
  MilitaryTech,
} from "@mui/icons-material";
export default function Milestones() {
  const theme = useTheme();
  const milestones = [
    {
      year: "۱۴۰۰",
      title: "از یک نیاز ساده تا تولد آدین‌زون",
      desc: `قدم‌به‌قدم، از دل نیازها و تجربه‌ها، خانواده‌ای ساخته شد به اسم آدین‌زون `,
      icon: <Stars />,
      color: "#FF6B6B",
    },
    {
      year: "۱۴۰۱",
      title: "شروع مسیر | کانال مربیگری ورزشی",
      desc: "یه راه ساده برای رشد و یادگیری.",
      icon: <Storefront />,
      color: "#4ECDC4",
    },
    {
      year: "۱۴۰۲",
      title: "رسیدن به ۱۰k کاربر",
      desc: "عبور از مرز ۱۰ هزار کاربر فعال",
      icon: <People />,
      color: "#45B7D1",
    },
    {
      year: "۱۴۰۳",
      title: "ادامه مسیر | سکانس ورزشی",
      desc: "در ۲۴ آبان ۱۴۰۲،پیج سکانس ورزشی متولد شد.",
      icon: <EmojiEvents />,
      color: "#F7B731",
    },
  ];

  const items = milestones.map((item, index) => (
    <Grid size={{ xs: 6, md: 3 }} key={index}>
      <Box
        sx={{
          textAlign: "center",
          p: 2,
          m: 1,
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          "&:hover": {
            transform: "translateY(-6px)",
            "& .milestone-icon": {
              transform: "rotateY(180deg)",
            },
          },
        }}
      >
        <Box
          className="milestone-icon"
          sx={{
            width: 70,
            height: 70,
            mx: "auto",
            mb: 2,
            borderRadius: "50%",
            background: `${item.color}15`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
            "& svg": {
              fontSize: 36,
              color: item.color,
            },
          }}
        >
          {item.icon}
        </Box>
        <Typography
          sx={{
            fontSize: "1rem",
            fontWeight: 700,
            color: item.color,
            mb: 0.5,
          }}
        >
          {item.year}
        </Typography>
        <Typography sx={{ fontSize: "0.9rem", fontWeight: 600, mb: 0.5 }}>
          {item.title}
        </Typography>
        <Typography sx={{ fontSize: "0.7rem", color: "text.secondary" }}>
          {item.desc}
        </Typography>
      </Box>
    </Grid>
  ));
  return (
    <Box
      sx={{
        mb: 10,
        p: 4,
        borderRadius: 5,
        background: `linear-gradient(135deg, ${theme.palette.primary.main}08, ${theme.palette.secondary.main}08)`,
        border: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Box sx={{ textAlign: "center", mb: 5 }}>
        <Typography sx={{ fontSize: "1.5rem", fontWeight: 700, mb: 1 }}>
          نقاط عطف ما
        </Typography>
        <Typography
          sx={{
            fontSize: "0.85rem",
            color: "text.secondary",
            maxWidth: 500,
            mx: "auto",
          }}
        >
          افتخاراتی که تا امروز به دست آوردیم
        </Typography>
      </Box>

      <Grid container>{items}</Grid>

      <Divider sx={{ my: 4 }} />

      <Box sx={{ textAlign: "center" }}>
        <Typography
          sx={{
            fontSize: "1rem",
            fontWeight: 600,
            mb: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <EmojiEvents sx={{ color: theme.palette.primary.main }} />
          و این تازه اول ماجراست...
          <MilitaryTech sx={{ color: theme.palette.secondary.main }} />
        </Typography>
        <Typography sx={{ fontSize: "0.8rem", color: "text.secondary" }}>
          هر روز داریم بزرگتر و بهتر می‌شیم. به زودی افتخارات بیشتری در راهه!
        </Typography>
      </Box>
    </Box>
  );
}
